import { render, staticRenderFns } from "./OperaReceiveWeightWindow.vue?vue&type=template&id=6877f912&"
import script from "./OperaReceiveWeightWindow.vue?vue&type=script&lang=js&"
export * from "./OperaReceiveWeightWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports